<template>
  <div class="pagination-container d-flex align-items-center justify-content-between">
    <!-- Prev button -->
     <div>
       <b-button class="button-pagination-brandme button-arrows" @click="prevPage" v-if="current_page !== 1">
         <feather-icon icon="ArrowLeftIcon" class="icon-chevron" />
       </b-button>
     </div>

    <!-- Page buttons -->
    <div class="d-flex align-items-center gap-1">
      <div v-for="(page, index) in pages" :key="index">
        <span v-if="page === '...'" class="dots">...</span>
        <b-button
          v-else
          :class="['button-pagination-brandme', { active: current_page === page }]"
          class="button-no-outline media-query-middle-buttons"
          @click="updateCurrentPage(page)"
        >
          {{ formatPage(page) }}
        </b-button>
      </div>
    </div>

    <!-- Next button -->
     <div>
       <b-button class="button-pagination-brandme ml-05 button-arrows" @click="nextPage" v-if="current_page !== total_pages">
         <feather-icon icon="ArrowRightIcon" class="icon-chevron" />
       </b-button>
     </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  name: 'paginationBrandmeV2',
  components: { BButton },
  props: {
    current_page: {
      type: Number,
      default: 1
    },
    total_rows: {
      type: Number,
      default: 10
    },
    per_page: {
      type: Number,
      default: 10
    },
  },
  computed: {
    total_pages() {
      return Math.ceil(this.total_rows / this.per_page)
    },
    pages() {
      const total = this.total_pages;
      const current = this.current_page;
      const pages = [];

      if (total <= 7) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        pages.push(1);

        if (current > 3) pages.push('...');

        const start = Math.max(2, current - 1);
        const end = Math.min(total - 1, current + 1);

        for (let i = start; i <= end; i++) {
          if (i !== 1 && i !== total) {
            pages.push(i);
          }
        }

        if (current < total - 2) pages.push('...');

        pages.push(total);
      }

      return pages;
    }

  },
  methods: {
    updateCurrentPage(page) {
      this.$emit('update_current_page', page);
    },
    nextPage() {
      if (this.current_page < this.total_pages) {
        this.updateCurrentPage(this.current_page + 1)
      }
    },
    prevPage() {
      if (this.current_page > 1) {
        this.updateCurrentPage(this.current_page - 1)
      }
    },
    formatPage(page) {
      return String(page).padStart(2, '0')
    }
  }
}
</script>

<style scoped lang="scss">
.pagination-container {
  column-gap: 1rem;
}
.gap-1 {
  gap: 1rem;
  @media(max-width: 768px) {
    gap: 0.4rem;
  }
}
.button-no-outline {
  color: #7F7F7F !important;
  font-family: 'avenir-light';
  box-shadow: none !important;
}

.button-pagination-brandme {
  height: 40px;
  min-width: 40px;
  box-shadow: none;
  transition: all 0.2s ease;
  background-color: transparent !important;
  border: none !important;

  &.active {
    color: black !important;
    font-family: 'avenir-medium';
    border: 1px solid #D1D5DB !important;
  }

  &:hover {
    background-color: #F9F9FA !important;
  }

  &:disabled {
    background-color: #f7f8f9;
    border-color: #dadada;
    cursor: not-allowed;
  }

  .icon-chevron {
    width: 15px;
    height: 15px;
  }
}
.media-query-middle-buttons { 
  @media(max-width: 768px) {
    min-width: 20px;
    height: 20px;
    padding: 0 2px;
    font-size: .75rem;
  }
}
.button-arrows {
  background: #e9E8E8 !important;
  color: #444 !important;
  box-shadow: none !important;
  width: 40px !important;
  padding: 0 !important;

  &:hover {
    background-color: #EFEFEE !important;
  }
}

.dots {
  color: #aaa;
  font-weight: bold;
}
.ml-05 {
  margin-left: 0.5em;
}
</style>
